<!--用电服务-单位概况  usePowerUnit-->
<template>
  <div class="usePowerUnitBody custom-scrollbar heighted">
    <!-- 通用-单位信息 -->
    <unitInfo class="smallWindow smallWindowMargin heighted" style="height:300px;"></unitInfo>
    <!-- 通用-月事件告警统计环比 -->
    <workStateNoWork class="smallWindow heighted" style="height:300px;"></workStateNoWork>
    <!-- 通用-单位日负荷 -->
    <dayInfo class="bigWindow heighted"></dayInfo>
    <!-- 通用-单位年统计 -->
    <yearOrMonthkWh class="marginTop bigWindow heighted" style="width: 99.8%;"></yearOrMonthkWh>
    <div style="height: 10px;width: 100%;"></div>
  </div>
</template>
<script>
  import unitInfo from '@/page/unitKanBan2/component/unitInfo.vue'
  import workStateNoWork from '@/page/unitKanBan2/component/workStateNoWork.vue'
  import dayInfo from '@/page/unitKanBan2/component/dayInfo.vue'
  import yearOrMonthkWh from '@/page/unitKanBan2/component/yearOrMonthkWh.vue'
  import unitStore from '@/cache/unitStore.js'
  export default {
    components: {
      unitInfo,
      workStateNoWork,
      dayInfo,
      yearOrMonthkWh,
    },
    props: [],
    data () {
      return {}
    },
    created () {
    },
    mounted () {},
    destroyed () {},
    computed: {},
    watch: {},
    methods: {
    }
  }
</script>

<style scoped>
  .usePowerUnitBody {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    height: calc(100% - 35px);
    padding: 1%;
    overflow: auto;
  }

  .smallWindow {
    width: calc(50% - 6px);
  }


  .smallWindowMargin {
    margin-right: 8px;
  }

  .marginTop {
    margin-top: 8px;
  }

  .bigWindow {
    width: 100%;
    height: 270px;
  }

  @media screen and (max-width: 1200px) {
    .smallWindow {
      width: 100%;
    }

    .smallWindowMargin {
      margin-right: 0;
      margin-bottom: 8px;
    }

    .bigWindow {
      height: auto;
      min-height: 270px;
    }
  }

  .heighted {
    height: 30%;
    min-height: 270px;
  }
</style>